import { useTranslation } from "@opendash/i18n";
import { Form, Input } from "antd";
import React, { useEffect } from "react";
import { useTypedWatch } from "./hooks/useTypedWatch";
import ClassFieldSelect from "./inputs/ClassFieldSelect";
import ClassSelect from "./inputs/ClassSelect";
import OperationList from "./inputs/OperationList";
import ValueOverwritesList from "./inputs/ValueOverwritesList";
import { Operation } from "./types/FormValues";

const FormContentWrapper = () => {
  const form = Form.useFormInstance();
  const className = useTypedWatch("className");
  const classFields = useTypedWatch("keys");
  const operations = useTypedWatch("operations");
  const t = useTranslation();

  // reset fields depending on the parse class selection
  useEffect(() => {
    form.resetFields(["keys"]);
    form.resetFields(["operations"]);
  }, [className]);

  // reset fields depending on the parse class fields selection
  useEffect(() => {
    if (!operations) return;

    const invalidOperations = operations.filter(
      (op: Operation) => !classFields?.includes(op?.field?.value)
    );

    form.setFieldsValue({
      operations: operations.filter(
        (o) =>
          !invalidOperations.some((op) => op?.field.value === o?.field.value)
      ),
    });
  }, [classFields]);

  return (
    <>
      <ClassSelect />
      <Form.Item name="limit" label={t("openware:parse.form.limit.label")}>
        <Input type="number" />
      </Form.Item>
      <Form.Item name="skip" label={t("openware:parse.form.skip.label")}>
        <Input type="number" />
      </Form.Item>
      {className && <ClassFieldSelect />}
      {classFields && <OperationList />}
      {classFields && <ValueOverwritesList />}
    </>
  );
};

export default FormContentWrapper;
